import src from "IMAGE";
export default { src, width: 61, height: 60, blurWidth: 0, blurHeight: 0};
